import React, { useEffect, useState } from 'react';
import { History } from 'lucide-react';
import api from '../lib/api';

const STATUS = { pending: 'En attente', confirmed: 'Confirmé', completed: 'Terminé', cancelled: 'Annulé' };
const fmt = (iso) => (iso ? new Date(iso).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '');

const label = (e) => {
  if (e.type === 'created') return 'Demande reçue';
  if (e.type === 'status_changed') return `Statut : ${STATUS[e.from_status] || e.from_status || '—'} → ${STATUS[e.to_status] || e.to_status}`;
  if (e.type === 'reservation_requested') return 'Réservation demandée — créneau bloqué en attente de validation';
  if (e.type === 'slots_released') return 'Créneau libéré';
  if (e.type === 'slots_reacquired') return 'Créneau de nouveau bloqué';
  if (e.type === 'rescheduled') return 'Rendez-vous déplacé';
  if (e.type === 'gcal_synced') return 'Google Agenda : événement créé / mis à jour';
  if (e.type === 'gcal_deleted') return 'Google Agenda : événement supprimé';
  if (e.type === 'gcal_error') return 'Google Agenda : échec de synchronisation';
  if (e.type === 'review_email_sent') return "E-mail de demande d'avis Google envoyé";
  if (e.type === 'current_status') return `Statut actuel « ${STATUS[e.to_status] || e.to_status} » — date du changement inconnue`;
  return e.type;
};

const detail = (e) => {
  if (e.type === 'current_status') return e.last_updated_at ? `Dernière modification connue le ${fmt(e.last_updated_at)}` : '';
  return [e.note, fmt(e.at), e.by].filter(Boolean).join(' · ');
};

const Row = ({ e, i }) => (
  <li className="flex gap-3 py-1.5" data-testid={`history-event-${i}`}>
    <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${e.reconstructed ? 'bg-slate-300' : 'bg-[hsl(207,90%,54%)]'}`} />
    <div className="text-sm">
      <p className="text-slate-900 font-medium">
        {label(e)}
        {e.reconstructed && <span className="ml-2 text-xs px-1.5 py-0.5 rounded bg-slate-100 text-slate-500" data-testid={`history-reconstructed-${i}`}>reconstitué</span>}
      </p>
      <p className="text-xs text-slate-500">{detail(e)}</p>
    </div>
  </li>
);

export const QuoteHistory = ({ quoteId, refreshKey }) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/admin/quotes/${quoteId}/history`)
      .then(({ data }) => {
        const all = [...data.reconstructed, ...data.events];
        all.sort((a, b) => (a.at || a.last_updated_at || '').localeCompare(b.at || b.last_updated_at || ''));
        if (alive) setItems(all);
      })
      .catch(() => alive && setItems([]));
    return () => { alive = false; };
  }, [quoteId, refreshKey]);

  return (
    <div className="mt-4" data-testid="quote-history">
      <div className="flex items-center gap-2 text-xs uppercase font-bold text-slate-500 mb-1"><History className="w-3.5 h-3.5" />Historique</div>
      {items === null ? <p className="text-sm text-slate-400">Chargement…</p>
        : items.length === 0 ? <p className="text-sm text-slate-400" data-testid="history-empty">Aucun événement.</p>
          : <ul>{items.map((e, i) => <Row key={e.id || `${e.type}-${i}`} e={e} i={i} />)}</ul>}
      {items?.some((e) => e.reconstructed) && (
        <p className="text-xs text-slate-400 mt-1" data-testid="history-reconstructed-note">« reconstitué » : déduit des dates enregistrées sur le devis, avant la mise en place de l'historique.</p>
      )}
    </div>
  );
};
